module.exports = __webpack_public_path__ + "815da88655f7426832f10f1cf5bbec09.png";